import React, { useState } from 'react';
import { Button, useNotify, useRefresh, useUnselectAll, useUpdateMany } from "react-admin";
import Popover from "@material-ui/core/Popover";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import { useQueryWithStore } from "react-admin";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import ActiveIcon from "@material-ui/icons/AddLocationOutlined";

const MoveToDepartmentPopover = props => {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [department, setDepartment] = useState(0);
    const { selectedIds } = props;
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll();
    const [updateMany] = useUpdateMany(
        'employees',
        selectedIds,
        { departmentId: department === "null" ? null : department },
        {
            onSuccess: () => {
                refresh();
                notify(` ${selectedIds.length} Employees Moved to ${department === "null" ? "No Department" : departments.find(s => s.id === department).name}`);
                unselectAll('employees');
            },
            onFailure: error => notify('Error: Some Employees cannot be moved', 'warning'),
        }
    );


    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMove = () => {
        updateMany()
        setAnchorEl(null);
    };
    const { data: departments } = useQueryWithStore({
        type: 'getList',
        resource: 'departments',
        payload: { filter: {}, pagination: {}, sort: {} }
    });

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <div>
            <Button label={props.label} aria-describedby={id} variant="text" color="primary" onClick={handleClick}>
                <ActiveIcon />
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Card style={{ minWidth: 100 }}>
                    <CardContent>
                        <FormControl margin='normal' >
                            <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                To Department
                            </InputLabel>
                            <Select
                                value={department}
                                onChange={ev => {
                                    setDepartment(ev.target.value)
                                }
                                }
                            >
                                <MenuItem key="no-dep" value="null" >No Department</MenuItem>
                                {departments && departments.map(ot => <MenuItem key={ot.id} value={ot.id}>{ot.name}</MenuItem>)}
                            </Select>
                        </FormControl>

                    </CardContent>
                    <CardActions>
                        <Button label='OK' disabled={!department} style={{ marginLeft: 'auto' }} onClick={handleMove} variant="text" color="primary">

                        </Button>
                    </CardActions>
                </Card>

            </Popover>
        </div>
    );
};

export default MoveToDepartmentPopover;
